import React from 'react'
import MaxWidthGridV2 from 'Layout/MaxWidthGridV2'
import PropTypes from 'prop-types'

// import css from './styles.js'
import { _Container } from './styles'

/* eslint-disable */
const ExtraDescription = ({ title = '', descriptions, hideIntro = false }) => {
  if(
    !descriptions ||
    ((hideIntro || !descriptions.intro) && !descriptions.whats_nearby && !descriptions.getting_around)
  ) return ''
  return (
    <_Container>
      <MaxWidthGridV2>
        <h2>{title}</h2>
        {!hideIntro && descriptions?.intro && <div dangerouslySetInnerHTML={{ __html: descriptions.intro }} />}
        {descriptions?.whats_nearby && <div dangerouslySetInnerHTML={{ __html: descriptions.whats_nearby }} />}
        {descriptions?.getting_around && <div dangerouslySetInnerHTML={{ __html: descriptions.getting_around }} />}
      </MaxWidthGridV2>
    </_Container>
  )
}

/* eslint-enable  */
ExtraDescription.propTypes = {
  title: PropTypes.string,
  descriptions: PropTypes.oneOfType([
    PropTypes.shape({
      intro: PropTypes.string,
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
}

export default ExtraDescription

